



import { Component, Mixins } from 'vue-property-decorator'
import Challenge from '@/components/organisms/study/Challenge.vue'
import Contents2 from '@/views/student/study/Contents2.vue'

@Component({
  components: {
    Challenge,
  },
})
export default class Challenge3 extends Mixins(Contents2) {}
